"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineEntry = void 0;
var TimelineEntry;
(function (TimelineEntry) {
    let type;
    (function (type) {
        type["AUTO"] = "Auto";
        type["MANUAL"] = "Manual";
        type["CUSTOM"] = "Custom";
        type["COMMENT"] = "Comment";
        type["NOTE"] = "Note";
        type["NOTE_COMMENT"] = "NoteComment";
        type["DEPLOYMENT_STATE_CHANGED"] = "DeploymentStateChanged";
        type["DEPLOYMENT_CONFIGURATION_CHANGED"] = "DeploymentConfigurationChanged";
        type["DEPLOYMENT_DELIVERABLE_CONFIGURATION_CHANGED"] = "DeploymentDeliverableConfigurationChanged";
        type["DEPLOYMENT_DELIVERABLE_CHANGED"] = "DeploymentDeliverableChanged";
        type["DEPLOYMENT_OUTREACH"] = "DeploymentOutreach";
    })(type = TimelineEntry.type || (TimelineEntry.type = {}));
})(TimelineEntry = exports.TimelineEntry || (exports.TimelineEntry = {}));
